import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import IndexPage from 'flarum/forum/components/IndexPage';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
import ActivityFeed from './components/ActivityFeed';
import NhBanner from './components/NhBanner';
import trackPageViews from './analytics';
import addStatus from './addStatus';
export { default as extend } from './extend';
app.initializers.add('neverhack-forum-nodes', () => {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('nhForums', LinkButton.component({
      href: app.route('nh.forums'),
      icon: 'fas fa-layer-group'
    }, app.translator.trans('neverhack-forum-nodes.lib.forums')), 95);
    items.add('nhDonate', LinkButton.component({
      href: app.route('nh.donate'),
      icon: 'fas fa-heart',
      className: 'NhDonate-navItem'
    }, app.translator.trans('neverhack-forum-nodes.lib.donate')), 60);
  });

  // «Поддержать» button in the header.
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add('nhDonate', LinkButton.component({
      href: app.route('nh.donate'),
      icon: 'fas fa-heart',
      className: 'Button Button--link NhDonate-headerButton'
    }, app.translator.trans('neverhack-forum-nodes.lib.donate')), 25);
  });

  // Shop banner and activity feed above the discussion list on the index page.
  extend(IndexPage.prototype, 'contentItems', function (items) {
    items.add('nhBanner', m(NhBanner, null), 96);
    items.add('nhFeed', m(ActivityFeed, null), 95);
  });
  addStatus();
  trackPageViews();
});
import './forum';